<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in typeList" :key="index"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "BatteryType",
    props: ["value"],
    watch: {
      value: {
        immediate: true,
        handler: function(value) {
          this.data = value;
        }

      },

    },
    data() {
      return {
        data: "",
        typeList: [{
            name: "镍氢",
            value: "1"
          },
          {
            name: "磷酸铁锂",
            value: "2"
          },
          {
            name: "锰酸锂",
            value: "3"
          },
          {
            name: "钴酸锂",
            value: "4"
          },
          {
            name: "三元",
            value: "5"
          },
          {
            name: "钛酸锂",
            value: "6"
          },
          {
            name: "其他",
            value: "7"
          }
        ]
      }
    },
    methods: {
      handleChange(value) {
        this.data = value;
        this.$emit("input", value)
      }
    }
  }
</script>

<style scoped>

</style>
